// ─────────────────────────────────────────────────────────────────────────────
// POPULAR SEARCHES CONFIG — edit these anytime, no other changes needed
// ─────────────────────────────────────────────────────────────────────────────
const POPULAR_SEARCH_GROUPS = [
  // {
  //   label: 'Mundhygiene',
  //   terms: [
  //     { text: 'Ayurvedische Zahnpasta',     url: '/search?q=Zahnpasta' },
  //     { text: 'Zahnpflege für Zahnfleisch', url: '/search?q=Zahnfleisch' },
  //     { text: 'Zungenreiniger',             url: '/search?q=Zungenreiniger' },
  //   ],
  // },
  // {
  //   label: 'Nahrungsergänzungen',
  //   terms: [
  //     { text: 'Amrit Kalash',               url: '/search?q=Amrit+Kalash' },
  //     { text: 'Haarvitamine',               url: '/search?q=Haarvitamine' },
  //     { text: 'Eisen Supplement',           url: '/search?q=Eisen' },
  //   ],
  // },
  // {
  //   label: 'Frauen Gesundheit',
  //   terms: [
  //     { text: 'Hormonbalance',              url: '/search?q=Hormonbalance' },
  //     { text: 'Verdauung',                  url: '/search?q=Verdauung' },
  //     { text: 'Wohlbefinden',               url: '/search?q=Wohlbefinden' },
  //   ],
  // },
];
// ─────────────────────────────────────────────────────────────────────────────

class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
    // Popular search pill clicks
    this.addEventListener('click', this.handlePopularTermClick.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();

    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    this.updateSearchForTerm(this.searchTerm, newSearchTerm);
    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    // Extract keywords from natural language questions, then fetch
    const searchQuery = this.extractKeywords(this.searchTerm);
    const cleanedQuery = searchQuery.replace(/[^a-zA-Z0-9]/g, '');

if (!cleanedQuery.length) {
  this.closeResults();

  this.predictiveSearchResults.innerHTML = `
    <div class="predictive-search__results-groups-wrapper">
      <div class="predictive-search__section">
        <p class="predictive-search__heading text-body">
          No results found
        </p>
      </div>
    </div>
  `;

  this.open();
  return;
}

this.showFilteredPopularSearches(this.searchTerm);
this.getSearchResults(searchQuery);
  }

onFormSubmit(event) {
  const query = this.getQuery();
  const cleanedQuery = query.replace(/[^a-zA-Z0-9]/g, '');

  if (
    !cleanedQuery.length ||
    this.querySelector('[aria-selected="true"] a')
  ) {
    event.preventDefault();
    return;
  }
}

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) {
      // Empty box — show popular searches panel
      this.showPopularSearches();
      return;
    }

    if (this.searchTerm !== currentSearchTerm) {
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.extractKeywords(this.searchTerm));
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) {
      this.showPopularSearches();
      return;
    }
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':   this.switchOption('up');   break;
      case 'ArrowDown': this.switchOption('down'); break;
      case 'Enter':     this.selectOption();       break;
    }
  }

  onKeydown(event) {
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  // ── Popular searches: show all groups on empty focus ──────────────────────
  showPopularSearches() {
    const html = this.buildPopularSearchesHTML(POPULAR_SEARCH_GROUPS);
    this.predictiveSearchResults.innerHTML = html;
    this.setAttribute('results', true);
    this.open();
  }

  // ── Popular searches: filter while typing ─────────────────────────────────
  showFilteredPopularSearches(query) {
    const lower = query.toLowerCase();
    const filtered = POPULAR_SEARCH_GROUPS
      .map((group) => ({
        ...group,
        terms: group.terms.filter((t) => t.text.toLowerCase().includes(lower)),
      }))
      .filter((group) => group.terms.length > 0);

    if (!filtered.length) return;

    // Prepend a popular-search block above the live API results
    const existing = this.predictiveSearchResults.querySelector('.predictive-search__popular-searches');
    if (existing) existing.remove();

    const wrapper = document.createElement('div');
    wrapper.innerHTML = this.buildPopularSearchesHTML(filtered);
    const panel = wrapper.firstElementChild;
    this.predictiveSearchResults.prepend(panel);
  }

  buildPopularSearchesHTML(groups) {
    const searchIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>`;

    const groupsHTML = groups.map((group) => {
      const itemsHTML = group.terms.map((term) => `
        <li class="predictive-search__list-item predictive-search__popular-item" role="option" aria-selected="false">
          <button
            type="button"
            class="predictive-search__item predictive-search__item--popular link link--text"
            data-popular-term="${term.text}"
            data-popular-url="${term.url}"
            tabindex="-1"
          >
            <div class="predictive-search__item-content predictive-search__item-content--centered predictive-search__item-content--query">
              <span class="predictive-search__query-icon">${searchIcon}</span>
              <p class="predictive-search__item-heading h5">${term.text}</p>
            </div>
          </button>
        </li>
      `).join('');

      return `
        <div class="predictive-search__popular-group">
          <h2 class="predictive-search__heading text-body caption-with-letter-spacing">${group.label}</h2>
          <ul class="predictive-search__results-list list-unstyled" role="group">${itemsHTML}</ul>
        </div>
      `;
    }).join('');

    return `<div class="predictive-search__popular-searches">${groupsHTML}</div>`;
  }

  // Handle clicks on popular search buttons (fill input + fetch live results)
  handlePopularTermClick(event) {
    const btn = event.target.closest('[data-popular-term]');
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();

    const term = btn.getAttribute('data-popular-term');
    this.input.value = term;
    this.input.focus();
    this.searchTerm = term;
    this.getSearchResults(term);
  }

  // ── Helpers ───────────────────────────────────────────────────────────────
  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) return;
      searchForTextElement.innerText = currentButtonText.replace(previousTerm, newTerm);
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allVisibleElements = Array.from(
      this.querySelectorAll('li, button.predictive-search__item')
    ).filter((el) => el.offsetParent !== null);

    let activeElementIndex = 0;
    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;
    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) selectedElementIndex = i;
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];
    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
    if (selectedOption) selectedOption.click();
  }

  // ── Keyword extractor ─────────────────────────────────────────────────────
  // Strips question/filler words from natural language queries (EN + DE)
  // so Shopify receives clean product keywords instead of full sentences.
  //
  // Examples:
  //   "what skin care do you have"   → "skin care"
  //   "suggest digestion products"   → "digestion products"
  //   "was hilft bei Verdauung"      → "Verdauung"
  //   "welche Produkte für Frauen"   → "Produkte Frauen"
  //   "digestion"                    → "digestion"  (unchanged, no stop words)
  // ─────────────────────────────────────────────────────────────────────────
  extractKeywords(query) {
    const words = query.trim().split(/\s+/);

    const stopWords = new Set([
      // ── English question words ──
      'what', 'which', 'why', 'how', 'when', 'where', 'who',
      // ── English filler / action words ──
      'is', 'are', 'the', 'a', 'an', 'for', 'to', 'in', 'of',
      'do', 'does', 'can', 'i', 'my', 'me', 'be', 'best', 'good',
      'help', 'with', 'and', 'or', 'vs', 'better', 'than', 'most',
      'more', 'some', 'any', 'give', 'tell', 'find', 'show', 'about',
      'should', 'would', 'could', 'will', 'use', 'using', 'used',
      'get', 'getting', 'have', 'has', 'having', 'make', 'makes',
      'its', 'it', 'this', 'that', 'these', 'those', 'your', 'our',
      'their', 'his', 'her', 'there', 'here', 'also', 'just', 'only',
      'very', 'really', 'much', 'many',
      // ── English action/suggest words (NEW) ──
      'suggest', 'suggested', 'recommend', 'recommended', 'need', 'needs',
      'want', 'wants', 'looking', 'buy', 'order', 'purchase', 'try',
      'trying', 'search', 'something', 'anything', 'products', 'product',
      'items', 'item', 'you', 'do', 'have', 'got', 'got',
      // ── English descriptive filler ──
      'natural', 'naturally', 'effective', 'effectively', 'improve',
      'support', 'helps', 'works', 'work', 'great', 'top', 'high',
      'low', 'based', 'take', 'taking',
      // ── German question words ──
      'was', 'welche', 'welcher', 'welches', 'welchen', 'welchem',
      'wie', 'wann', 'wo', 'wer', 'wen', 'wem', 'wessen',
      // ── German articles & prepositions ──
      'ist', 'sind', 'die', 'der', 'das', 'den', 'dem', 'des',
      'ein', 'eine', 'einen', 'einem', 'einer', 'eines',
      'für', 'zu', 'in', 'von', 'bei', 'mit', 'und', 'oder',
      'gegen', 'nach', 'über', 'unter', 'auf', 'an', 'durch',
      'ob', 'als', 'auch', 'noch', 'schon', 'nur', 'sehr',
      // ── German action/filler words ──
      'hilft', 'helfen', 'kann', 'ich', 'mein', 'meine', 'meinen',
      'gibt', 'gute', 'guten', 'guter', 'gutes', 'nehmen', 'haben',
      'hat', 'beim', 'wird', 'werden', 'bitte', 'empfehlen', 'empfehle',
      'suche', 'suchen', 'brauche', 'brauchen', 'kaufen', 'bestellen',
      'zeig', 'zeige', 'zeigen', 'hätten', 'haben', 'habt', 'habe',
      'möchte', 'möchten', 'wäre', 'wären', 'bitte', 'danke',
    ]);

    // Strip punctuation from each word before checking stop list
    const keywords = words.filter(
      (w) => !stopWords.has(w.toLowerCase().replace(/[?!,.\-]/g, ''))
    );

    // If filtering removed everything, fall back to the original query
    // so Shopify still gets something to search with
    return keywords.length >= 1 ? keywords.join(' ') : query;
  }

  getSearchResults(searchTerm) {
    
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    const params = new URLSearchParams({
      q: searchTerm,
      section_id: 'predictive-search',
      'resources[type]': 'product,collection,query,page,article',
      'resources[limit]': '5',
      'resources[limit_scope]': 'each',
      'resources[options][unavailable_products]': 'last',
    });

    fetch(`${routes.predictive_search_url}?${params}`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          this.close();
          throw new Error(response.status);
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;

        this.allPredictiveSearchInstances.forEach((instance) => {
          instance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) return;
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');
    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;
    setTimeout(() => { this.statusElement.setAttribute('aria-hidden', 'true'); }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    // Keep any filtered popular-searches panel above live results
    const popularPanel = this.predictiveSearchResults.querySelector('.predictive-search__popular-searches');
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    if (popularPanel) {
      this.predictiveSearchResults.prepend(popularPanel);
    }

    this.setAttribute('results', true);
    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');
    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);